import { gql } from '@apollo/client';
import { EXPORT_INSTITUTION } from '../../fragments';

export const EXPORT_PROMOTION_SCHOOLS = gql`
  query ExportPromotionSchools($input: ExportArgs!) {
    institutions: allPromotionSchools(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...exportInstitution
        }
      }
    }
  }
  ${EXPORT_INSTITUTION}
`;
